var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-area",class:{
    'upload-area_disabled': _vm.disabled,
    'upload-area_enabled': !_vm.disabled,
    'active:shadow-xl': !_vm.disabled,
  },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('i',{staticClass:"upload-area__icon material-icons",class:{ 'upload-area__icon_enabled': !_vm.disabled }},[_vm._v(" touch_app ")]),_c('p',{staticClass:"mb-0 text-xs"},[_vm._v(" "+_vm._s(_vm.uploadAreaTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }